import React from 'react';
import Header from '../../components/header/header';

const About = () => {
    return (
       <>
       <Header />
       </>
    );
};

export default About;